import { max, min } from "d3-array";
import { scaleLinear, scaleTime } from "d3-scale";
import { CurrentItem, Series } from "./types";

function allValues<R, K extends keyof CurrentItem<Date, R>>(series: Series<R>[], key: K): CurrentItem<Date, R>[K][] {
  return series.flatMap(s => s.values.map(i => i[key]));
}

export const useChartValues = function <R = null>(series: Series<R> | Series<R>[], width: number, height: number) {
  const seriesArray = Array.isArray(series) ? series : [series];

  const maxY = max(allValues<R, "y">(seriesArray, "y"))!;
  const minX = min(allValues<R, "x">(seriesArray, "x"))!;
  const maxX = max(allValues<R, "x">(seriesArray, "x"))!;

  const x = scaleTime().domain([minX, maxX]).range([0, width]);
  const y = scaleLinear().domain([0, maxY]).range([height, 0]);

  return { maxY, minX, maxX, x, y };
};
